import type { BioContent } from "@fitties/shared";
import { resolveBioContent } from "@fitties/shared";
import clsx from "clsx";
import { MessageBubble } from "./MessageBubble";

export interface BioMessageChainProps {
  bio?: string | null | undefined;
  bioContent?: BioContent | null | undefined;
  compact?: boolean;
  emptyLabel?: string;
  className?: string;
}

export function BioMessageChain({
  bio,
  bioContent,
  compact = false,
  emptyLabel = "No bio available",
  className,
}: BioMessageChainProps) {
  const resolved = resolveBioContent({ bio, bioContent });

  if (!resolved) {
    return (
      <p className={className} data-testid="bio-message-chain-empty">
        {emptyLabel}
      </p>
    );
  }

  return (
    <div
      className={clsx("flex flex-col", compact ? "gap-0.5" : "gap-2", className)}
      data-testid="bio-message-chain"
      data-kind={resolved.kind}
      data-compact={compact ? "true" : "false"}
    >
      {resolved.kind === "qa" ? (
        <>
          <MessageBubble text={resolved.question} variant="received" testId="bio-message-question" />
          <MessageBubble text={resolved.answer} variant="sent" testId="bio-message-answer" />
        </>
      ) : (
        <MessageBubble text={resolved.text} variant="received" testId="bio-message-text" />
      )}
    </div>
  );
}
